var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBacktotop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.41401L5.70699 15.707C5.31699 16.097 4.68299 16.097 4.29299 15.707C3.90299 15.317 3.90299 14.683 4.29299 14.293L11.293 7.29301C11.683 6.90201 12.317 6.90201 12.707 7.29301L19.707 14.293C20.097 14.683 20.097 15.317 19.707 15.707C19.317 16.097 18.683 16.097 18.293 15.707L12 9.41401Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBacktotop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backtotop.9ca40caa0da3c627ba990ef4a576fc44.svg";